<template>
    <div class="gh-page gh-page--home">

        <div class="gh-hero">
            <div class="container gh-hero__container">
                <div class="gh-hero__content">
                    <h1 class="gh-hero__heading">Advance your clinical skills and meet your CPD needs with Australia’s leading mental health learning community.</h1>
                    <h2 class="gh-hero__subheading">{{ LaraVue && LaraVue.figure.totalNumberOfCourses }}+ courses. {{ LaraVue && LaraVue.figure.totalAuthors }}+ global experts. Access 24/7.</h2>
                    <div class="gh-hero__cta">
                        <router-link class="gh-button-redesign gh-button-redesign--cta" to="/join">Join Now</router-link>
                        <router-link class="gh-button-redesign gh-button-redesign--primary" to="/catalogue">View Courses</router-link>
                    </div>
                </div>
            </div>
        </div>

        <gh-newsletter-view></gh-newsletter-view>

        <!-- Intro -->
        <div class="gh-section gh-benefits">
            <div class="container">
                <el-row :gutter="40">
                    <el-col
                        v-for="(benefit, index) in benefits"
                        :key="index"
                        :xs="24" :sm="12" :md="6">
                        <img :src="benefit.image" :alt="benefit.title" width="80" height="80" loading="lazy">
                        <p class="gh-benefit__title">{{ benefit.title }}</p>
                        <p class="gh-benefit__description">{{ benefit.description }}</p>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="gh-section featured-programs">
            <div class="container">
                <h2 class="gh-section__heading gh-section__heading-large">Explore our Membership Courses</h2>
                <p class="gh-section__subheading">Access {{ LaraVue.figure.totalNumberOfCourses }}+ CPD courses covering hundreds of topics in psychology & mental health.</p>
                <gh-featured-programs course-type="membership-courses"/>
            </div>
        </div>

        <div class="gh-section featured-programs featured-programs-crendetial">
            <div class="container">
                <h2 class="gh-section__heading gh-section__heading-large">Explore our Micro-credential Courses</h2>
                <p class="gh-section__subheading">Take a deep-dive with some of the world’s leading mental health & wellbeing experts.</p>

                <gh-featured-programs course-type="credential-courses"/>
            </div>
        </div>

        <gh-how-it-works/>

        <div class="gh-section gh-section-global-experts">
            <div class="container">
                <div class="gh-global-experts-content">
                    <div class="gh-global-experts-content-inner">
                        <h1 class="gh-global-experts-heading gh-section__heading gh-section__heading-large">Learn from Global Experts in Mental Health</h1>
                        <p>We work with {{ LaraVue && LaraVue.figure.totalAuthors }}+ renowned experts in their fields, including practitioners, authors, researchers and educators.</p>
                        <div class="action">
                            <router-link class="gh-button-redesign gh-button-redesign--primary gh-button-home-redesign" to="/team">Our Experts</router-link>
                        </div>
                    </div>
                </div>
                <div class="gh-global-experts-image">
                    <img :src="setImage('/images/app/global-experts', 'png')" alt="Credential Course Authors" width="550" height="356" loading="lazy">
                </div>
            </div>
        </div>

        <div class="gh-section gh-testimonials">
            <div class="container">
                <h2 class="gh-section__heading">Feedback from some of our delighted learners</h2>
                <el-row>
                    <el-col :span="24" :md="18">
                        <div class="gh-rates-left">
                            <span>Over 1,500 learners have rated their MHA experience 4.9 out of 5 stars</span>
                            <div class="gh-read-more-reviews gh-read-more-reviews-1">
                                <a href="//www.productreview.com.au/listings/mental-health-academy " class="gh-button-redesign gh-button-redesign--primary" target="_blank">View their reviews</a>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24" :md="6">
                        <div class="gh-rates-right">
                            <img src="/images/app/5-star-graphic.svg" alt="Purple star" width="20" height="20" class="gh-rates-image" loading="lazy">
                        </div>
                    </el-col>
                    <el-col>
                        <div class="gh-read-more-reviews gh-read-more-reviews-2">
                                <a href="//www.productreview.com.au/listings/mental-health-academy " class="gh-button-redesign gh-button-redesign--primary" target="_blank">View their reviews</a>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <gh-testimonials :items="testimonials"/>
        </div>

        <div class="gh-section gh-section-join-community">
            <div class="container">
                <div class="gh-join-community-content">
                    <img src="/images/app/join-group-image.png" width="185" height="79" alt="Join Group" loading="lazy">
                    <h2 class="gh-join-community-heading .gh-section__heading text-center">Join our community today</h2>
                    <p class="gh-section__subheading">As an MHA member, you’ll enjoy unrestricted access to {{ LaraVue.figure.totalHours }}+ hours of mental health CPD covering hundreds of topics - for less than $1/day.</p>
                    <div class="action">
                        <router-link class="gh-button-redesign gh-button-home-redesign" to="/join">Join Now</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ghFeaturedPrograms from './components/featuredPrograms.vue';
    import ghHowItWorks from './components/howItWorks.vue';
    import ghMhaFeatures from './components/mhaFeatures.vue';
    import ghTestimonials from './components/Testimonials';
    import allTestimonials from '@/modules/testimonial/contents/testimonialsV2'

    export default {
        components: {
            ghTestimonials,
            ghFeaturedPrograms,
            ghHowItWorks,
            ghMhaFeatures
        },

        data() {
            return {
                benefits: [
                    {
                        title: 'Be first to knowledge',
                        description: LaraVue.figure.totalNumberOfCourses + '+ courses from global experts in mental health, covering dozens of topics.',
                        image: 'images/app/home-knowledge.png'
                    },
                    {
                        title: 'Get more, for less',
                        description: 'Enjoy world-class learning and cutting-edge tools for less than $1/day.',
                        image: 'images/app/home-getmore.png'
                    },
                    {
                        title: 'Learn from anywhere',
                        description: `Access ${LaraVue.figure.totalHours}+ hours of videos and readings – all online, on-demand, 24/7.`,
                        image: 'images/app/home-learn-anywhere.png'
                    },
                    {
                        title: 'Accrue CPD Hours',
                        description: 'Learn new skills while meeting your professional development requirements.',
                        image: 'images/app/home-accrue-hours.png'
                    }
                ]
            }
        },

        computed: {
            LaraVue() {
                return LaraVue
            },

            testimonials() {
                return allTestimonials.filter(testimonial => testimonial.excerpt)
            },

            isSupportWebpImages() {
                return this.$root.webpSupported
            }
        },

        methods: {
            setImage(path, extension) {
                if (this.isSupportWebpImages) {
                    return path + '.webp'
                }
                return path + '.' + extension;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .gh-come-join {
        color: inherit;
        font-weight: inherit;
        text-decoration: underline;
    }

    .gh-global-experts-image img {
        height: auto !important;
    }
</style>
